import React, { useState } from 'react';
import ErrorBoundary from '../../../ErrorBoundary';
import { Input } from 'reactstrap';

const InputCellRender = ({
  rowData,
  columnName,
  updateRowValue,
  required = false,
  hasTouched = false,errAccountNum,
  validationError
}) => {

  const subProps = {};
  const value = rowData[columnName] || '';
  const [text, setText] = useState(value);

  const handlerChange = (event) => {
    debugger;
    const { value } = event.target;
    setText(value);
    updateRowValue(value, columnName,rowData);
  };

  const touced = required && hasTouched;

  if (touced) {
    subProps.title = 'Reason is required';
  }

  return (
    <div>
      <ErrorBoundary>
        <form>
          <Input
            type='text'
            name={columnName}
            id='comments'
            value={text}
           // hidden={(rowData.mapingStatus == "UnMappedChargeCode" && columnName == "bupp") || (rowData.mapingStatus == "UnmappedNDC" && columnName == "bupp") || (rowData.mapingStatus == "Historicalmappings" && columnName == "bupp")}
            invalid={touced ? Boolean(!text) : validationError ? !!validationError : false}
            onChange={handlerChange}
            autoComplete='off'
            className={`${required ? 'required' : ''}`}
            {...subProps}
          />
          {errAccountNum && <div className="text-danger">Please add an Acct# between 1-15 character</div>}
          {validationError && (<div className="text-danger"> {validationError}</div>)}
        </form>
      </ErrorBoundary>
    </div>
  );
};

export default InputCellRender;
